import { IconFish, IconFlower, IconBug, IconPlant } from '@tabler/icons-react';
import type { LivestockType } from '@/types/livestock';

export const LIVESTOCK_TYPE_META: Record<LivestockType, { label: string; Icon: typeof IconFish }> = {
  fish: { label: 'Fish', Icon: IconFish },
  coral: { label: 'Coral', Icon: IconFlower },
  invertebrate: { label: 'Invertebrate', Icon: IconBug },
  plant: { label: 'Plant', Icon: IconPlant },
};

/** Buttons in a page or section header (Tank Shots, the organism page): 44 px on a phone. */
export const HEADER_BUTTON_HEIGHT = { base: 44, sm: 36 };
